import { Fragment } from 'react';
import styles from '../styles.module.scss';
import classNames from 'classnames';
import { Col, Row } from 'components-antd';
import { CCtag } from 'components/Icons/CCtag';

export const FormRecipients = ({ formDetails }) => {
  const { copyRecipients, updateRecipients, isCompleted } = formDetails;

  const allRecipients = [...(copyRecipients || []), ...(updateRecipients || [])];

  if (!allRecipients.length) return null;

  return (
    <div className={styles.formRecipients}>
      {allRecipients.length > 0 && (
        <div className={styles.trackingTabItems}>
          {allRecipients.map((val, index) => (
            <Row
              className={classNames(styles.formUsersRow, styles.avatarWrapper, styles.ccRow)}
              key={index}
            >
              <div className={styles.info}>
                <Col className={styles.signatureCountRow}>
                  <CCtag stroke={isCompleted ? '#00B152' : ''} />
                </Col>

                <Col>
                  <p className={styles.usersName}>
                    {val.Id ? val.FirstName + ' ' + val.LastName : val.Email}
                  </p>
                </Col>
              </div>

              <div className={styles.itemAction}>
                <Col className={styles.status}>
                  {isCompleted ? <span>Updates Sent</span> : <span>Copy Not Sent</span>}
                </Col>
              </div>
            </Row>
          ))}
        </div>
      )}
    </div>
  );
};
